module.exports = __webpack_public_path__ + "static/media/toulon4.3490009f.jpg";